import { prefetchQueries } from '$lib/util/prefetchUtil.js';
import type { PageLoadEvent, EntryGenerator } from './$types';
import { ProductApi } from '$lib/api/productApi';
import { CartApi } from '$lib/api/cartApi';
import { MediaApi } from '$lib/api/mediaApi';
import { supportedLocales } from '$lib/i18n/initI18n.js';
import type { SitemapProductResponse } from '$lib/api/types/sitemapProductResponse.js';
import type { ApiSchemas } from '$lib/api/shopwareApi.js';

export const prerender = false;

export const entries: EntryGenerator = async () => {
    const allProducts: SitemapProductResponse['elements'] = [];

    let productResponse: SitemapProductResponse;
    let page = 1;

    do {
        productResponse = await ProductApi.listProductsForSitemap(page, fetch);
        console.log(
            `Loading products ${productResponse.limit * (productResponse.page - 1)} - ${productResponse.limit * (productResponse.page - 1) + productResponse.total}`
        );
        allProducts.push(...productResponse.elements);
        page++;
    } while (productResponse.total >= productResponse.limit);

    return supportedLocales.flatMap((lang) =>
        allProducts.map((product: ApiSchemas['Product']) => ({ language: lang, productSlug: product.productNumber }))
    );
};

export const load = prefetchQueries<PageLoadEvent>(async (fetchImpl, shopContext, params, event) => {
    const { queryClient } = await event.parent();

    const product = await queryClient.fetchQuery({
        queryKey: ['product', params.productSlug],
        queryFn: ({ queryKey }) => ProductApi.getProductByNumber(queryKey[1], shopContext, fetch),
        staleTime: 2 * 60 * 1000,
        gcTime: 3 * 60 * 1000
    });

    return [
        {
            queryKey: ['banner', [product.translated.customFields.custom_lewo_erp_banner]],
            queryFn: ({ queryKey }) => MediaApi.getMedia({ ids: queryKey[1] as string[] }, shopContext),
            enabled: product?.translated?.customFields?.custom_lewo_erp_banner !== undefined
        },
        {
            queryKey: ['variants', product?.parentId],
            queryFn: () => ProductApi.getAllVariantsOfProduct(product.parentId, shopContext),
            staleTime: 120 * 1000,
            gcTime: 180 * 1000,
            enabled: product?.translated?.customFields?.custom_lewo_erp_category === 'Wein'
        },
        {
            queryKey: ['cart'],
            queryFn: () => CartApi.getCart(shopContext),
            staleTime: 30 * 1000,
            gcTime: 120 * 1000
        }
    ];
});
